import axiosInstance from '@/lib/enhancedAxiosInstance';
import { logError } from '@/utils/errorHandler';

export interface FeedbackSubmission {
  message: string;
  email?: string;
  page_url?: string;
}

export interface Feedback {
  id: number;
  message: string;
  email?: string;
  page_url?: string;
  created_at: string;
}

export interface FeedbackResponse {
  id: number;
  message: string;
  email?: string;
  page_url?: string;
  created_at: string;
}

/**
 * Submit feedback to the API
 */
export async function submitFeedback(data: FeedbackSubmission): Promise<FeedbackResponse> {
  try {
    const response = await axiosInstance.post<FeedbackResponse>('/api/feedback/', {
      message: data.message,
      email: data.email || null,
      page_url: data.page_url || window.location.href,
    });

    return response.data;
  } catch (error) {
    logError(
      'Failed to submit feedback',
      {
        component: 'feedbackService',
        action: 'submitFeedback',
        metadata: { data, error },
      },
      { showToast: false, userFacing: false }
    );
    throw error;
  }
}

/**
 * Get user's feedback history (for admins)
 */
export async function getFeedbackHistory(): Promise<Feedback[]> {
  try {
    const response = await axiosInstance.get<Feedback[]>('/api/feedback/');
    return response.data;
  } catch (error) {
    logError(
      'Failed to get feedback history',
      {
        component: 'feedbackService',
        action: 'getFeedbackHistory',
        metadata: { error },
      },
      { showToast: false, userFacing: false }
    );
    throw error;
  }
}
